module.exports = __webpack_public_path__ + "img/LI288771.04ac2cea.png";